var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10V13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10V18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10V23Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14V13Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14V18Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H20V8H12V4ZM7 28V7H10V10H22V7H25V13H27V7C27 5.896 26.1 5 25 5H22V4C22 2.896 21.104 2 20 2H12C10.895 2 10 2.896 10 4V5H7C5.895 5 5 5.896 5 7V28C5 29.105 5.895 30 7 30H12V28H7Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21.5902L24.414 20.0042L26 18.4182L27.586 20.0042L26 21.5902ZM19.586 28.0042H18V26.4182L23 21.4182L24.586 23.0042L19.586 28.0042ZM29.707 19.2972L26.707 16.2972C26.316 15.9062 25.684 15.9062 25.293 16.2972L16 25.5902V30.0042H20.414L29.707 20.7112C30.098 20.3202 30.098 19.6882 29.707 19.2972Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.8d612cf88b360f750bbbab226195b0db.svg";
export { ForwardRef as ReactComponent };